exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1LONyCpnGd1utLnF_DRWah{overflow:hidden;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}html[dir] ._1LONyCpnGd1utLnF_DRWah{margin-top:48px}", ""]);

// exports
exports.locals = {
	"container": "_1LONyCpnGd1utLnF_DRWah"
};